(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemPreviewModalCtrl", ["previewData", "$filter", learningItemPreviewModalCtrl]);
    /*
    Basic previewData object
    {
        typeIconCssClass: "ion ion-beer",
        typeName: "Meu tipo favorito",
        typeId: 2,
        itemName: "Item Name",
        itemPriorityItem: true,
        itemExpires: false,
        itemExpireDays: 1,
        itemExpireMonths: 0,
        itemExpireYears: 1,
        itemTimeDays: 1,
        itemTimeHours: 1,
        itemTimeMinutes: 0,
        itemDescription: "Desc"
    }*/
    function learningItemPreviewModalCtrl(previewData, $filter) {
        var vm = this;
        vm.expireDuration = "";
        vm.assignmentStatusClass = "assigned";
        vm.assignment = previewData;
        vm.expireDuration = $filter("duration")(vm.assignment.itemExpireYears + ":" + vm.assignment.itemExpireMonths + ":" + vm.assignment.itemExpireDays, "yMd");
        switch (vm.assignment.typeId) {
            case 1:
                vm.customView = "app/learningItems/preview/learningItemType/downloadsPreviewView.html";
                break;
            case 2:
                vm.customView = "app/learningItems/preview/learningItemType/externalQualificationPreview.html";
                break;
            case 3:
            case 12:
                vm.customView = "app/learningItems/preview/learningItemType/onlineExamPreviewView.html";
                break;
            case 4:
                vm.customView = "app/learningItems/preview/learningItemType/onlineLessonPreview.html";
                break;
            case 5:
                vm.customView = "app/learningItems/preview/learningItemType/practicalEvaluationPreview.html";
                break;
            case 6:
                vm.customView = "app/learningItems/preview/learningItemType/externalUrlPreviewView.html";
                break;
            case 7:
                vm.customView = "app/learningItems/preview/learningItemType/seminarPreviewView.html";
                break;
            case 8:
                vm.customView = "app/learningItems/preview/learningItemType/webinarPreviewView.html";
                break;
            case 10:
                vm.customView = "app/learningItems/preview/learningItemType/learningJournalPreviewView.html";
                break;
            case 11:
                vm.customView = "app/learningItems/preview/learningItemType/assignmentPreviewView.html";
                break;
            case 13:
                vm.customView = "app/learningItems/preview/learningItemType/workHistoryPreviewView.html";
                break;
        }
    }
}());
